import { render, staticRenderFns } from "./EmailAndMobileDuplicates.vue?vue&type=template&id=501aaf6d&scoped=true&"
import script from "./EmailAndMobileDuplicates.vue?vue&type=script&lang=js&"
export * from "./EmailAndMobileDuplicates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501aaf6d",
  null
  
)

export default component.exports